import './styles/view.css';

/**
 * Selects a tab.
 *
 * @param {HTMLElement} tab
 */
const selectTab = (tab) => {
  if (!tab) {
    return;
  }

  tab?.setAttribute('tabindex', 0);
  tab?.setAttribute('aria-selected', true);
  const correspondingTabPanel = document?.getElementById(tab?.getAttribute('aria-controls'));

  if (!correspondingTabPanel) {
    return;
  }

  correspondingTabPanel?.removeAttribute('hidden');
};

/**
 * Resets all tabs.
 *
 * @param {HTMLElement} tab
 */
const resetTabs = (tab) => {
  if (!tab) {
    return;
  }

  const tabsBlock = tab?.closest('.wp-block-rothschild-site-config-content-tabs');

  if (!tabsBlock) {
    return;
  }

  const tabNavigationButtons = tabsBlock?.querySelectorAll('[role="tablist"] button');

  if (!tabNavigationButtons?.length === 0) {
    return;
  }

  tabNavigationButtons.forEach((tabNavigationButton) => {
    if (tabNavigationButton?.id === tab?.id) {
      return;
    }

    tabNavigationButton?.setAttribute('tabindex', -1);
    tabNavigationButton?.setAttribute('aria-selected', false);

    const correspondingTabPanel = document?.getElementById(
      tabNavigationButton?.getAttribute('aria-controls'),
    );

    if (!correspondingTabPanel) {
      return;
    }

    correspondingTabPanel?.setAttribute('hidden', true);
  });
};

/**
 * Handle tab button click.
 *
 * @param {Object} event
 */
const handleClick = (event) => {
  if (
    event?.target?.tagName !== 'BUTTON' ||
    event?.target?.getAttribute('aria-selected') === 'true'
  ) {
    return;
  }

  resetTabs(event?.target);
  selectTab(event?.target);
};

/**
 * Handle tab arrow key navigation.
 *
 * @param {Object} event
 */
const handleKeyDown = (event) => {
  const allowedKeys = ['ArrowRight', 'ArrowLeft'];

  if (!allowedKeys?.includes(event?.key) || event?.target?.tagName !== 'BUTTON') {
    return;
  }

  if (event?.key === 'ArrowRight') {
    if (event?.target?.nextElementSibling) {
      event?.target?.nextElementSibling.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
      });

      event?.target?.nextElementSibling.focus();
      return;
    }

    event?.target?.parentElement?.firstElementChild?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
    });

    event?.target?.parentElement?.firstElementChild?.focus();
  }

  if (event?.key === 'ArrowLeft') {
    if (event?.target?.previousElementSibling) {
      event?.target?.previousElementSibling.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
      });

      event?.target?.previousElementSibling.focus();
      return;
    }

    event?.target?.parentElement?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
    });

    event?.target?.parentElement?.lastElementChild?.focus();
  }
};

(() => {
  const tabsBlocks = document?.querySelectorAll('.wp-block-rothschild-site-config-content-tabs');

  if (tabsBlocks?.length === 0) {
    return;
  }

  tabsBlocks.forEach((tabsBlock) => {
    const tabNavigation = tabsBlock?.querySelector('[role="tablist"]');

    if (!tabNavigation) {
      return;
    }

    selectTab(tabNavigation?.firstElementChild);

    Array.from(tabNavigation?.children)?.forEach((tabButton) => {
      tabButton.addEventListener('click', handleClick);
      tabButton.addEventListener('keydown', handleKeyDown);
    });
  });
})();
